<template>
  <footer class="footer px-4">
    <b-row align-v="center" class="justify-content-lg-between">
      <b-col lg="6">
        <div class="copyright text-center text-lg-left text-muted">
          <a
            href="https://plataformaexitos.com.br"
            class="font-weight-bold ml-1 text-exitos"
            target="_blank"
          >
            Plataforma Exitos
          </a>
          <badge-commit />
        </div>
      </b-col>
      <b-col lg="6">
        <b-nav align="center" class="nav-footer justify-content-lg-end">
          <p class="text-sm mb-0" v-html="titleEnv" />
        </b-nav>
      </b-col>
    </b-row>
  </footer>
</template>
<script>
import BadgeCommit from "@/components/BadgeCommit.vue";
import { useLastCommit } from "@/composables/useLastCommit";
import { computed, defineComponent } from "vue";

export default defineComponent({
  components: {
    BadgeCommit,
  },
  setup() {
    const year = new Date().getFullYear();
    const { $isHMG: $isDev } = useLastCommit();

    const yearMessage = `© ${year}`;

    const titleClass = computed(() => ($isDev ? "text-exitos" : "text-danger"));

    const titleEnv = computed(() =>
      $isDev
        ? `Você está em ambiente de <span class="font-weight-bold ${titleClass.value}">homologação</span>`
        : `Você está em ambiente de <span class="font-weight-bold ${titleClass.value}">produção</span>`
    );

    return {
      titleEnv,
      year,
      yearMessage,
    };
  },
});
</script>
